import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useEffect } from "react";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import GoogleAnalytics from "./components/common/GoogleAnalytics";
import MetaPixelAnalytics from "./components/common/MetaPixelAnalytics";
import AppRoutes from "./routes/AppRoutes";
import { useAuthStore } from "./store/useAuthStore";
// Fix #5: wire React Router navigate into the Axios interceptor
import { setNavigate } from "./services/apiClient";

import "./styles/google-translate.css";

function AppContent() {
  const initializeAuth = useAuthStore((state) => state.initializeAuth);
  const navigate = useNavigate();

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  // Fix #5: give the Axios interceptor access to React Router's navigate
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <>
      <GoogleAnalytics />
      <MetaPixelAnalytics />
      <AppRoutes />
    </>
  );
}

function App() {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "";

  if (process.env.NODE_ENV === "development") {
    return (
      <GoogleOAuthProvider clientId={clientId}>
        <Router>
          <ReactQueryDevtools initialIsOpen={false} />
          <AppContent />
        </Router>
      </GoogleOAuthProvider>
    );
  }
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Router>
        <AppContent />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
